import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeleteStreamEntrypointsMutation } from "../graphql/mutations";
import type {
  DeleteStreamEntrypointsMutationType,
  DeleteStreamEntrypointsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeleteStreamEntrypointsMutation = (
  options?: MutationHookOptions<
    DeleteStreamEntrypointsMutationType,
    DeleteStreamEntrypointsMutationVariablesType
  >
) => {
  return useMutation<
    DeleteStreamEntrypointsMutationType,
    DeleteStreamEntrypointsMutationVariablesType
  >(DeleteStreamEntrypointsMutation, options);
};
